import { APP } from '@advanza/advanza_generic'
import { useAppSelector } from 'hooks/hooks'
import React from 'react'

const OfficeLogo = () => {
    const { countryCode } = useAppSelector((state) => state.countries)[0] || {}
    const logoName =
        {
            NL: 'trustoologo_2+.svg',
            BE: 'trustlocal_logo_be_2+.svg',
            DE: 'trustlocal_logo_de_2+.svg',
        }[countryCode] || 'trustoologo_2+.svg'

    return <img width={100} src={`${APP.S3_PUBLIC()}${logoName}`} />
}

export default OfficeLogo
